import React, { Fragment, useContext, useEffect, useState } from 'react'
import {
  Toolbar,
  AppBar as MUIAppBar,
  makeStyles,
  IconButton,
  Typography,
  Hidden,
  Tooltip,
  Badge,
  Icon,
  colors,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import clsx from 'clsx'
import Ribbon from '../../public/ribbon/Ribbon'
import { ColorEnum, RolesEnum, screenWidth } from '../../../enum'
import SvgIcon from '../../public/picture/svgIcon'
import Context from './Context'
import routes from '../../../routes'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CreditCardIcon from '@material-ui/icons/CreditCard'
import { Message } from '../../../services/api'
import Utils from '../../public/utility/Utils'
import NotificationMenu from './appbar/NotificationMenu'
import UserMenu from './appbar/UserMenu'
import { connect, ConnectedProps } from 'react-redux'
import {
  confirmSweetAlert,
  goto,
  hasPermission,
  isAdmin,
  JwtData,
  sweetAlert,
} from '../../../utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faUserCircle,
  faBell,
  faPlusSquare,
  faBars,
  faCreditCard,
  faHome,
  faCartPlus,
} from '@fortawesome/free-solid-svg-icons'
import { relative } from 'path'

const drawerWidth = 240
const { getUserMessages } = new Message()
const isTrial = false

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  alert: {
    width: '100%',
    marginTop: 5,
    textAlign: 'center',
  },
  toolbar: {
    paddingRight: 24,
  },
  trialToolbar: {
    paddingRight: 70,
  },
  imgLog: {
    margin: 0,
    background: '#f2f2f2',
    borderRadius: 10,
    marginBottom: -10,
    width: '150px',
    '@media(max-width: 750px)': {
      width: '95px',
    },
  },
  titleLog: {
    display: 'none',
    '@media(max-width: 750px)': {
      fontWeight: 700,
      fontSize: '19px',
      lineHeight: '30px',
      letterSpacing: '-0.03em',
      color: '#3D2294',
      display: 'inline-block',
      position: 'absolute',
      paddingTop: '2px',
    },
  },
  subTitleLog: {
    display: 'none',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '20px',
    '@media(max-width: 959px)': {
      fontWeight: 700,
      fontSize: '10px',
      lineHeight: '16px',
      letterSpacing: '-0.02em',
      color: '#452B9A',
      display: 'block',
      marginTop: '-9px',
    },
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  drawerBackground: {
    background: '#F6F6F6',
  },
  daroogLogo: {
    width: '77% !important',
    height: '35px !important',
  },
  headerHolder: {
    width: '100%',
    padding: '16px',
  },
  logoType: {
    height: '30px',
  },
  systemTitle: {
    textAlign: 'right',
    display: 'block',
    fontSize: 'large',
    width: '100%',
    color: '#4625B2',
  },
  logoTypeHolder: {
    width: '60%',
    float: 'left',
  },
  roundicon: {
    background: 'white',
    float: 'right',
  },
  peopleAppBar: {
    // zIndex: theme.zIndex.drawer + 1,
    zIndex: 1040,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: 'transparent',
    maxWidth: '1100px',
    position: 'relative',
    margin: '0px auto',
  },
  appBar: {
    // zIndex: theme.zIndex.drawer + 1,
    zIndex: 1040,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: '#4625B2',
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 10,
    paddingTop: 18,
    paddingBottom: 18,
    marginLeft: -15,
    paddingLeft: 18,
    // color:
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
    cursor: 'pointer',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  userContainer: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(3),
    },
  },
  largeSpacing: {
    padding: theme.spacing(2),
  },
  divider: {
    backgroundColor: '#9585C9',
    height: '1px',
  },
  smallAvatar: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  largeAvatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  paleText: {
    color: ColorEnum.PaleGray,
  },
  appBarToolButton: {
    background: window.innerWidth <= screenWidth.sm ? '' : '#95D061',
    borderRadius: '30px',
    padding: '0px 24px 0px 4px',
  },
}))

interface AppBarProps {
  showButtons?: boolean
}

const mapStateToProps = (state: any) => ({
  transfer: state.transfer,
})

const connector = connect(mapStateToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

const AppBar: React.FC<AppBarProps & PropsFromRedux> = ({
  showButtons = true,
  transfer: _transfer,
}) => {
  const {
    setIsOpenDrawer,
    isOpenDrawer,
    setcreditAnchorEl,
    debtValueState,
    setAnchorEl,
    setNotifEl,
    setActiveStep,
    genericMessages,
    hasSubscribeState,
  } = useContext(Context)

  const history = useHistory()
  const { userData } = new JwtData()
  const pharmacyName = userData.pharmacyName
  const { t } = useTranslation()
  const {
    transfer,
    addSubscription,
    defaultPath,
    defaultPathForEndUser,
  } = routes

  const {
    trialToolbar,
    toolbar,
    appBar,
    peopleAppBar,
    menuButton,
    menuButtonHidden,
    title,
    appBarToolButton,
    imgLog,
    titleLog,
    subTitleLog,
  } = useStyles()
  const handleDrawerOpen = (): void => setIsOpenDrawer(true)

  const handleUserIconButton = (
    e: React.MouseEvent<HTMLButtonElement>,
  ): void => {
    setAnchorEl(e.currentTarget)
  }

  const handleNotificationIconButton = (
    e: React.MouseEvent<HTMLButtonElement>,
  ): void => {
    if (genericMessages && genericMessages.length > 0) {
      setNotifEl(e.currentTarget)
    } else {
      history.push(routes.pharmacyMessage)
    }
  }

  const newTransferHandler = async (): Promise<void> => {
    if (_transfer.isStarted) {
      const res = await confirmSweetAlert(
        'روند تبادل فعلی را حذف و دوباره شروع میکنید؟',
      )

      if (!res) {
        return
      }
      window.location.reload()
    }
    history.push(transfer + '?step=0')
  }

  const goToSubscription = async (): Promise<void> => {
    history.push('/dashboard/subscription/add-subscription')
  }

  const [version, setVersion] = useState('')
  // const [versionMainPart, setVersionMainPart] = useState('')
  // const [versionBuild, setVersionBuild] = useState('')
  const [expireDaysColor, setExpireDaysColor] = useState('#95D061')
  const expireDays = localStorage.getItem('SubscriptionExpireDays')
  useEffect(() => {
    const versionString = localStorage.getItem('version') ?? ''
    // Because we use semantic versioning - https://semver.org
    // const versionParts = versionString.split('+')
    setVersion(versionString)
    // setVersionMainPart(versionParts[0])
    // setVersionBuild(versionParts[1])

    if (expireDays != null) {
      if (Number(expireDays) < 3) {
        setExpireDaysColor('red')
      } else if (Number(expireDays) < 7) {
        setExpireDaysColor('orange')
      } else {
        setExpireDaysColor('#95D061')
      }
    } else {
      setExpireDaysColor('#95D061')
    }
    if (window.innerWidth <= screenWidth.sm) {
      setExpireDaysColor('')
    }
  }, [expireDays])

  const { roles } = new JwtData()
  let rolesArray = roles()
  const theme = useTheme()
  const isSmallDevice = useMediaQuery(theme.breakpoints.down('xs'))
  return (
    <MUIAppBar
      elevation={0}
      position="absolute"
      className={userData.pharmacyName != null ? appBar : peopleAppBar}
    >
      <Toolbar
        className={isTrial ? trialToolbar : toolbar}
        // style={{ marginTop: 10 }}
      >
        {isTrial && (
          <div style={{ zIndex: 0, overflow: 'hidden' }}>
            <Ribbon text="نسخه آزمایشی" isExchange={false} isToolbar={true} />
          </div>
        )}
        {(userData.pharmacyName != null ||
          isAdmin() ||
          hasPermission('declaration:alldeclaration') ||
          hasPermission('zboomparcel:getallparcels')) &&
          showButtons && (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(menuButton, isOpenDrawer && menuButtonHidden)}
          >
            <FontAwesomeIcon icon={faBars} />
          </IconButton>
        )}

        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          className={title}
          onClick={(e: any): void => {
            goto(
              history,
              pharmacyName ? defaultPath : defaultPathForEndUser,
              true,
            )
          }}
        >
          {userData.pharmacyName != null && (
            <>
              <FontAwesomeIcon
                icon={faHome}
                size="lg"
                style={{
                  position: 'relative',
                  // top: '-5px',
                  marginLeft: '10px',
                }}
              />
              {/* <span className={titleLog}>داروگ</span> */}
              <img className={imgLog} src="/images/logo.png" />
            </>
          )}
          {userData.pharmacyName == null && (
            <>
              <svg
                width="131"
                height="34"
                viewBox="0 0 131 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <rect
                  x="0.474609"
                  y="0.947388"
                  width="130"
                  height="32.2"
                  fill="url(#pattern0)"
                />
                <defs>
                  <pattern
                    id="pattern0"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                  >
                    <use
                      xlinkHref="#image0_1380_30"
                      transform="matrix(0.005 0 0 0.0201863 0 -0.0652174)"
                    />
                  </pattern>
                  <image
                    id="image0_1380_30"
                    width="200"
                    height="56"
                    xlinkHref="data:image/png;base64,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"
                  />
                </defs>
              </svg>
              <span className={titleLog}>داروگ</span>
              <span className={subTitleLog}>
                جستجوی سریع دارو در بین هزاران داروخانه در کشور
              </span>
            </>
          )}
          <Hidden smDown>
            {/* {t('general.dashboard')} */}
            <span>
              <span
                style={{
                  marginRight: 0,
                  fontSize: 24,
                  fontWeight: 700,
                  lineHeight: '38px',
                  color: '#452B9A',
                  position: 'absolute',
                  paddingBottom: '7px',
                }}
              >
                {t('general.daroog')}
              </span>
              {userData.pharmacyName == null && (
                <Fragment>
                  <span
                    style={{
                      fontSize: 13,
                      color: '#452B9A',
                      fontWeight: 400,
                      lineHeight: '20px',
                      display: 'block',
                      marginTop: '-9px',
                    }}
                  >
                    {t('general.peoplePanelInfo')}
                  </span>
                </Fragment>
              )}
            </span>
          </Hidden>

          {/* {version && (
            <span className="version-small">
              <Hidden xsDown>
                {t('general.version')} &nbsp;
                {version}
              </Hidden>
              <Hidden smUp>
                <span style={{ marginRight: 40 }}>{version}</span>
              </Hidden>
            </span>
          )} */}
        </Typography>
        {userData.pharmacyName != null &&
          rolesArray?.indexOf(RolesEnum.PHARMACY) >= 0 && (
            <Fragment>
              <Tooltip
                className={appBarToolButton}
                title={String(t('exchange.create'))}
              >
                <div>
                  <span>
                    <IconButton
                      edge="end"
                      style={{ color: ColorEnum.White }}
                      onClick={goToSubscription}
                    >
                      <FontAwesomeIcon size="xs" icon={faCartPlus} />
                      <Hidden smDown>
                        <span style={{ fontSize: 14, paddingRight: 6 }}>
                          {/* {t('exchange.create', {
                            var: _transfer.isStarted
                              ? t('general.again.0')
                              : '',
                          })} */}
                          خرید اشتراک
                        </span>
                      </Hidden>
                    </IconButton>
                  </span>
                  <span></span>
                </div>
              </Tooltip>
              {rolesArray?.indexOf(RolesEnum.PHARMACY) >= 0 && (
                // <Tooltip
                //   style={{
                //     background: expireDaysColor,
                //     borderRadius: '30px',
                //     padding: '0px 4px 0px 24px',
                //     marginRight: '8px',
                //   }}
                //   title={'خرید اشتراک'}
                // >
                //   <div>
                //     <span>
                //       <IconButton
                //         edge="end"
                //         style={{ color: ColorEnum.White }}
                //         onClick={(): void => {
                //           history.push(addSubscription)
                //         }}
                //       >
                //         <FontAwesomeIcon size="xs" icon={faCreditCard} />
                //         <Hidden smDown>
                //           <span style={{ fontSize: 14, paddingRight: 6 }}>
                //             {t('خرید اشتراک', {
                //               var: _transfer.isStarted
                //                 ? t('general.again.0')
                //                 : '',
                //             })}
                //           </span>
                //         </Hidden>
                //       </IconButton>
                //     </span>
                //     <span></span>
                //   </div>
                // </Tooltip>
                <></>
              )}
              {/* {Utils.hasSubscribe() && (
              <span style={{ fontSize: 12, marginRight: '8px' }}>
                {' '}
                <b>فعال</b>
              </span>
            )} */}
              {/* <Tooltip title="کیف پول">
              <IconButton
                edge="end"
                onClick={(e: any): void => setcreditAnchorEl(e.currentTarget)}
                style={{
                  color: `${
                    !debtValueState ? 'white' : debtValueState >= 0 ? '#f95e5e' : '#72fd72'
                  }`,
                }}
              >
                <CreditCardIcon />
                {debtValueState && (
                  <Hidden smDown>
                    <span style={{ fontSize: 14 }}>
                      {' '}
                      <b>{Utils.numberWithCommas(Math.abs(debtValueState))}</b>
                      <span style={{ fontSize: 10, marginRight: 2 }}>
                        {t('general.defaultCurrency')}
                      </span>
                    </span>
                  </Hidden>
                )}
              </IconButton>
            </Tooltip> */}
            </Fragment>
          )}
        {showButtons && userData.pharmacyName != null && (
          <>
            <Tooltip title={String(t('general.notifications'))}>
              <IconButton
                edge="end"
                color="inherit"
                onClick={handleNotificationIconButton}
              >
                <Badge badgeContent={genericMessages.length} color="secondary">
                  <FontAwesomeIcon icon={faBell} />
                </Badge>
              </IconButton>
            </Tooltip>

            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls="user-menu"
              aria-haspopup="true"
              onClick={handleUserIconButton}
              color="inherit"
            >
              <FontAwesomeIcon icon={faUserCircle} />
            </IconButton>
          </>
        )}
        {showButtons && userData.pharmacyName === null && (
          <>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls="user-menu"
              aria-haspopup="true"
              onClick={handleUserIconButton}
              color="inherit"
            >
              <span
                style={{
                  width: '100px',
                  fontWeight: 300,
                  fontSize: '12px',
                  lineHeight: '17px',
                  color: '#555555',
                }}
              >
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: '13px',
                    lineHeight: '20px',
                    textAlign: 'center',
                  }}
                >
                  {userData.name} {userData.family}
                </span>
                <br />
                {userData.mobile}
              </span>
              <img style={{ width: '45px' }} src="/images/profile.png" />
            </IconButton>
          </>
        )}
        <UserMenu />
        {genericMessages && genericMessages.length > 0 && (
          <NotificationMenu messages={genericMessages} />
        )}
      </Toolbar>
    </MUIAppBar>
  )
}

export default connector(AppBar)
